module.exports = __webpack_public_path__ + "img/no-text.a362f3d8.svg";